import React from 'react'

const AlertWrapper = ({ children }: { children?: React.ReactNode }) => {
  return (
    <div className='z-50 fixed top-0 left-0 w-full h-full bg-black/20 flex items-center justify-center p-4'>
      {children}
    </div>
  )
}

export default AlertWrapper